import axios from "axios";

export default class FAQ {
	constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getFAQ() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/bin/generals/Transport-FAQ`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async postFAQ(body, author) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/generals`,
        data: {
          name: "Transport-FAQ",
          title: "Reglamento",
          author: author,
          body: body
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}
